<template>
    <div class="order-payment-receipt-popover form">
        <div class="formrow">
            <EmailInput
                v-model:value="emailRecipient"
                ref="emailInputComponent"
                :allowAutocomplete="true"
                :displayIcon="false"
                @submit="sendReceipt"
            />
        </div>
        <SendOrderPaymentReceiptButton
            ref="sendReceiptButtonComponent"
            :emailRecipient="emailRecipient"
            :orderId="orderId"
            :locationId="locationId"
            :onSendReceiptSuccess="onSendReceiptSuccess"
            :onInvalidEmailProvided="onInvalidEmailProvided"
            :alwaysEnabled="true"
        />
        <PrintOrderPaymentReceiptButton
            v-if="isPrintButtonAvailable"
            :orderId="orderId"
            :locationId="locationId"
            :onPrintSuccess="onPrintSuccess"
        />
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from "vue";

    import EmailInput from "@/components/elements/EmailInput.vue";
    import PrintOrderPaymentReceiptButton from "@/components/payment/PrintOrderPaymentReceiptButton.vue";
    import SendOrderPaymentReceiptButton from "@/components/payment/SendOrderPaymentReceiptButton.vue";

    const props = defineProps<{
        locationId: string;
        orderId: string;
        userIsWaiter: boolean;
        onSendReceiptSuccess: () => void;
        onPrintSuccess: () => void;
    }>();

    // State
    const emailRecipient = ref<string | undefined>();
    const emailInputComponent = ref<InstanceType<typeof EmailInput> | null>(null);
    const sendReceiptButtonComponent = ref<InstanceType<typeof SendOrderPaymentReceiptButton> | null>(null);

    // Computed
    const isPrintButtonAvailable = computed(() => props.userIsWaiter);

    // Methods
    function onInvalidEmailProvided() {
        emailInputComponent.value?.setError(true);
        emailInputComponent.value?.focus();
    }

    function sendReceipt() {
        sendReceiptButtonComponent.value?.sendReceipt();
    }
</script>

<style lang="scss">
    .popover.sendreceipt {
        .form {
            margin-top: -10px;
        }
    }

    .order-payment-receipt-popover {
        .send-order-receipt-btn,
        .print-order-receipt-btn {
            &.v-btn.primary {
                margin: 7px 0 18px !important;
            }
        }
    }
</style>
